/* eslint-disable react/prop-types */
import { LockOpen, VpnKey } from "@mui/icons-material";
import { Box, Grid, Stack, Typography, darken, Alert } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SelectCustomer from "components/SelectCustomer";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useRef, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { API_ROUTES, API_URL, CODE_QUANGNAM } from "../../utils/constants";
import { AlertState } from "states";
import { useRecoilState } from "recoil";
import { LinkImage } from "utils";

const ALLVALUE = { ma: "ALL", ten: "Tất cả" };
const dictTrangThai = {
  1: "Đang chấm",
  2: "Đã hoàn thành",
};
const dictColorTrangThai = {
  1: "success",
  2: "warning",
};

function QuanLyHoiDong() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const _timeOut = useRef();
  const [tableData, setTableData] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [optionNhomSanPham, setOptionNhomSanPham] = useState([]);
  const [optionDistrict, setOptionDistrict] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [rowSelectionThanhVien, setRowSelectionThanhVien] = useState({});
  const [errors, setErrors] = useState();
  const [alert, setAlert] = useRecoilState(AlertState);
  const [validationErrors, setValidationErrors] = useState({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [paramsState, setParamsState] = useState({
    nam: null,
    nhomsanpham: ALLVALUE.ma,
    maquan: ALLVALUE.ma,
  });

  const handleToOpenStatus = async () => {
    const values = Object.keys(rowSelection).map((key) => Number(key));
    try {
      if (values?.length > 0) {
        const response = await axiosPrivateInstance.put(
          API_ROUTES.CAPNHATTRANGTHAI,
          {
            ...values,
          }
        );
        if (response?.data?.code == 200) {
          setAlert({
            alert: true,
            message: "Cập nhập trạng thái hội đồng thành công!",
            type: "success",
          });
          setRowSelection({});
          //   refresh data
          fetchData(paramsState, pagination);
        }
      } else {
        setAlert({
          alert: true,
          message:
            "Bạn chưa chọn hội đồng nào. Vui lòng chọn lại để cập nhập trạng thái!",
          type: "warning",
        });
      }
    } catch (error) {
      const ms = error.response.data[0];
      setAlert({ alert: true, message: ms, type: "warning" });
    }
  };

  useEffect(() => {
    const fetchDataHuyen = async (codeProvince) => {
      try {
        const response = await axiosPrivateInstance.get(API_ROUTES.GETHUYEN, {
          params: { tinh: codeProvince },
        });
        setOptionDistrict(response?.data);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    const fetchDataDataNhomSanPham = async () => {
      try {
        const response = await axiosPrivateInstance.get("nhomsanpham");
        setOptionNhomSanPham(response.data["data"]);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    fetchDataHuyen(CODE_QUANGNAM);
    fetchDataDataNhomSanPham();
    setRowSelection({});
    setRowSelectionThanhVien({});
  }, []);

  // Lấy toàn bộ dữ liệu
  const fetchData = async (
    { nam, nhomsanpham, maquan },
    { pageIndex, pageSize }
  ) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      let body = {
        nam: nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
        nhomsanpham: nhomsanpham == ALLVALUE.ma ? undefined : nhomsanpham,
        maquan: maquan == ALLVALUE.ma ? undefined : maquan,
        trangthai: 2,
        pageNumber: pageIndex + 1,
        countNumber: pageSize,
      };
      const response = await axiosPrivateInstance.get(API_ROUTES.CHAMDIEM, {
        params: body,
      });
      setRowCount(response.data?.totalRecord);
      setTableData(response.data?.data);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    _timeOut.current && clearTimeout(_timeOut.current);
    _timeOut.current = setTimeout(() => {
      fetchData(paramsState, pagination);
    }, [200]);
  }, [paramsState, pagination]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: true,
        enableColumnActions: false,
      },
      {
        accessorKey: "phieudangky_noidung",
        header: "Phiếu đăng ký",
        size: 120,
      },
      {
        accessorKey: "hoidong_trichyeu",
        header: "Hội đồng",
        size: 150,
      },
      {
        accessorKey: "sanpham_ten",
        header: "Sản phẩm",
        size: 150,
      },
      {
        accessorKey: "ngaycham",
        header: "Ngày chấm",
        size: 120,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value && dayjs(value).isValid()
            ? dayjs(value).format("DD/MM/YYYY")
            : "";
        },
      },
      {
        accessorKey: "tongdiem",
        header: "Tổng điểm",
        size: 120,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return typeof value == "number"
            ? parseFloat(value).toLocaleString("en-US")
            : value;
        },
        muiTableBodyCellProps: {
          align: "right",
        },
      },
      {
        accessorKey: "trangthai",
        header: "Trạng thái",
        size: 150,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={dictTrangThai[value]}
                color={dictColorTrangThai[value]}
                variant="gradient"
              />
            </MDBox>
          );
        },
      },
    ],
    []
  );

  const columnsThanhVien = useMemo(() => {
    let result = [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "anhdaidien",
        header: "Ảnh đại diện",
        size: 100,
        Cell: ({ cell }) => {
          const urlLink = cell.getValue()
            ? API_URL + "/media/" + cell.getValue()
            : LinkImage.userDefault;
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <img
                alt="avatar"
                height={48}
                width={48}
                className="object-cover w-12 h-12"
                src={urlLink}
                loading="lazy"
                style={{ borderRadius: "50%" }}
              />
            </Box>
          );
        },
      },
      {
        accessorKey: "ten",
        header: "Tên thành viên",
        size: 150,
      },
      {
        id: "ykiendanhgia",
        accessorFn: (row) =>
          row.phieudanhgia && row.phieudanhgia.length > 0
            ? row.phieudanhgia[0]?.ykiendanhgia
            : "",
        header: "Ý kiến đánh giá",
        size: 150,
        Cell: ({ renderedCellValue, row }) => <div>{renderedCellValue}</div>,
      },
      {
        accessorKey: "tongdiem",
        header: "Tổng điểm",
        size: 120,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return typeof value == "number"
            ? parseFloat(value).toLocaleString("en-US")
            : value;
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "phieudanhgia",
        header: "Trạng thái",
        size: 120,
        Cell: ({ cell }) => {
          const phieuDanhGia = cell.getValue();
          let value = 1;
          if (phieuDanhGia && phieuDanhGia.length > 0) {
            value = phieuDanhGia[0]?.trangthai;
          }
          return (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={dictTrangThai[value]}
                color={dictColorTrangThai[value]}
                variant="gradient"
              />
            </MDBox>
          );
        },
      },
    ];
    return result;
  }, []);
  //nam
  const handleChangeDate = (value) => {
    setParamsState((prev) => {
      return {
        ...prev,
        nam: value,
      };
    });
  };
  const handleToClearDate = () => {
    setParamsState((prev) => ({
      ...prev,
      nam: null,
    }));
  };
  //nhomsanpham
  const handleChangeNhomSanPham = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      nhomsanpham: value,
    }));
  };
  const handleChangeDistrict = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      maquan: value,
    }));
  };

  const handelClickThanhVienTable = async () => {
    const values = Object.keys(rowSelectionThanhVien).map((key) => Number(key));
    try {
      if (values?.length > 0) {
        const response = await axiosPrivateInstance.put(
          API_ROUTES.CAPNHAPTRANGTHAITHANHVIEN,
          {
            ...values,
          }
        );
        if (response?.data?.code == 200) {
          setAlert({
            alert: true,
            message: "Cập nhập trạng thái thành viên thành công!",
            type: "success",
          });
          setRowSelectionThanhVien({});
          //   refresh data
          fetchData(paramsState, pagination);
        }
      } else {
        setAlert({
          alert: true,
          message:
            "Bạn chưa chọn thành viên nào. Vui lòng chọn lại để cập nhập trạng thái!",
          type: "warning",
        });
      }
    } catch (error) {
      const ms = error.response.data[0];
      setAlert({ alert: true, message: ms, type: "warning" });
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Box>
          {errors && errors.error ? (
            <Grid container sx={{ textAlign: "center", mb: 0 }}>
              <Grid item xs={12}>
                <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                  {errors.error}
                </Alert>
              </Grid>
            </Grid>
          ) : (
            ""
          )}
        </Box>
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={12} md={4} lg={4}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={paramsState?.nam ? dayjs(paramsState.nam) : null}
                views={["year"]}
                onChange={handleChangeDate}
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    placeholder: "---Chọn năm---",
                    fullWidth: true,
                    inputProps: {
                      readOnly: true,
                    },
                  },
                  field: {
                    clearable: true,
                    onClear: handleToClearDate,
                  },
                }}
                label="Năm"
                sx={{
                  ".MuiInputLabel-shrink": {
                    fontSize: "0.875rem",
                    lineHeight: "1.6",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <SelectCustomer
              keyValue="nhomsanpham"
              label="Nhóm sản phẩm"
              labelName="ten"
              option={optionNhomSanPham}
              onChange={handleChangeNhomSanPham}
              state={paramsState.nhomsanpham}
              unicode="id"
            />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <SelectCustomer
              keyValue="maquan"
              label="Quận/Huyện"
              labelName="ten"
              option={optionDistrict}
              onChange={handleChangeDistrict}
              state={paramsState.maquan}
              unicode="ma"
            />
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={3}>
        <MaterialReactTable
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Lỗi khi lấy dữ liệu",
                }
              : undefined
          }
          enableRowNumbers
          rowNumberMode="static"
          columns={columns}
          data={tableData}
          enableRowActions={false}
          enableMultiRowSelection={true}
          enableRowSelection={true}
          getRowId={(row) => row.id} // Make sure each row has a unique ID
          onRowSelectionChange={setRowSelection}
          enableFilters={true}
          enableColumnOrdering={false}
          enableDensityToggle={true}
          enableColumnResizing
          enableGrouping
          manualPagination
          onPaginationChange={setPagination}
          rowCount={rowCount}
          enableSubRowSelection={true}
          localization={MRT_Localization_VI}
          positionActionsColumn="last"
          initialState={{
            isLoading: true,
            columnVisibility: {
              id: false,
            },
            density: "compact",
          }}
          renderTopToolbarCustomActions={() => (
            <Stack spacing={2} direction="row" color="white">
              {tableData.length > 0 ? (
                <MDButton
                  color="error"
                  variant="contained"
                  startIcon={<LockOpen />}
                  sx={{ color: "#ffffff" }}
                  onClick={handleToOpenStatus}
                >
                  Mở khoá
                </MDButton>
              ) : (
                <></>
              )}
            </Stack>
          )}
          state={{
            rowSelection,
            pagination,
            isLoading,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
          }}
          renderDetailPanel={({ row, table }) => {
            const dataItem = row.original;
            const list = dataItem?.thanhvien;
            return list?.length > 0 ? (
              <MaterialReactTable
                key={
                  "danhsachthanhvien_" +
                  String(row?.original?.id) +
                  "_" +
                  String(row?.original?.hoidong_id)
                }
                muiToolbarAlertBannerProps={
                  isError
                    ? {
                        color: "error",
                        children: "Lỗi khi lấy dữ liệu",
                      }
                    : undefined
                }
                enableEditing={false}
                columns={columnsThanhVien}
                data={list}
                enableRowActions={false}
                enableMultiRowSelection={true}
                enableRowSelection={true}
                getRowId={(row) => row.phieudanhgia?.[0]?.id}
                onRowSelectionChange={setRowSelectionThanhVien}
                enableFilters={true}
                enableHiding={false}
                enableColumnOrdering={false}
                enableDensityToggle={true}
                enableSubRowSelection={true}
                enableColumnResizing
                localization={MRT_Localization_VI}
                positionActionsColumn="last"
                initialState={{
                  isLoading: true,
                  columnVisibility: {
                    id: false,
                  },
                  pagination: { pageIndex: 0, pageSize: 5 },
                  density: "compact",
                }}
                state={{
                  isLoading,
                  rowSelection: rowSelectionThanhVien,
                  showAlertBanner: isError,
                  showProgressBars: isRefetching,
                }}
                displayColumnDefOptions={{
                  "mrt-row-actions": {
                    size: 50,
                  },
                }}
                renderTopToolbarCustomActions={() => (
                  <Stack spacing={2} direction="row" color="white">
                    <MDButton
                      color="warning"
                      variant="contained"
                      startIcon={<VpnKey />}
                      sx={{ color: "#ffffff" }}
                      onClick={handelClickThanhVienTable}
                    >
                      Mở khoá phiếu cho Thành viên
                    </MDButton>
                  </Stack>
                )}
                muiTablePaperProps={{
                  elevation: 0,
                  sx: {
                    borderRadius: "0",
                    border: "1px solid rgb(211 225 245)",
                    backgroundColor: "#fff",
                  },
                }}
                muiTableBodyProps={{
                  sx: (theme) => ({
                    "& tr:nth-of-type(odd)": {
                      backgroundColor: darken(
                        theme.palette.background.default,
                        0.1
                      ),
                    },
                  }),
                }}
                muiTableBodyCellProps={{
                  sx: {
                    whiteSpace: "break-spaces",
                  },
                }}
                muiTableHeadCellProps={{
                  sx: {
                    ".Mui-TableHeadCell-Content-Wrapper": {
                      whiteSpace: "break-spaces !important",
                      textAlign: "center",
                    },
                  },
                }}
              />
            ) : (
              <Box>
                <Typography textAlign={"center"}>
                  Không có thông tin của danh sách thành viên phiếu chấm
                </Typography>
              </Box>
            );
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid rgb(211 225 245)",
              backgroundColor: "#fff",
            },
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor: darken(theme.palette.background.default, 0.1),
              },
            }),
          }}
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default QuanLyHoiDong;
